module.exports = __webpack_public_path__ + "static/media/sdg_icon_1.1b23bfc3.png";